import axios from 'axios'
import { AUTH_SERVICE_URL, API_LISTS, ADMIN_SERVIE_URL } from '../helper/constant'
import { cacheService, UserEventsChecker } from '../helper/utils'

const loginInterface = {
    'username': 'username',
    'password': 'password'
}

const getLoginParams = ({ username, password }) => {
    return {
        [loginInterface['username']]: username,
        [loginInterface['password']]: password
    }
}

class Auth {
    static _data
    static accessToken
    static refreshToken
    static appClientId
    static userId   //We can have userId from cognitoTokens.
    static userPoolId

    static roleIds
    static rightObjects
    static rights
    static _rolesData
    static lastVersion
    static hideNewReleaseInfo
    static noRedirect

    static logoutFn;

    static userEmail;
    static _clear() {
        this._data = undefined
        this.accessToken = undefined
        this.refreshToken = undefined
        this.token = undefined
        this.userId = undefined
        this.userPoolId = undefined

        this.username = undefined
        this._rolesData = undefined;
        this.lastVersion = undefined
        this.hideNewReleaseInfo = false;
        this.noRedirect = undefined;
    }

    static _clearCache() {
        //console.log('Token Cache clear')
        cacheService.removeCache('data')
        cacheService.removeCache('roles')
        cacheService.removeCache('releaseVersion')
        cacheService.removeCache('releaseVersionShown')
    }

    static setPortalInfo(portalId, clientId) {
        //console.log('setPortalInfo', portalId, clientId)
        this.programId = portalId
        this.clientId = clientId
    }

    static setData(inputData) {
        //console.log('Set UserData')
        let data = this._data = Object.assign({}, JSON.parse(JSON.stringify(inputData)));
        // this.accessToken = this._data.accessToken = (data['accessToken'] || data['access'])
        // this.refreshToken = this._data.refreshToken = (data['refreshToken'] || data['refresh'])
        // delete this._data['access']
        // delete this._data['refresh']
        this.token = data['token']
        this.expiry = data['expiry'] || 0
        this.expiryInterval = data['expiryInterval'] || 30

        this.username = data['username']
        this.userId = data['userId']
        this.isSupervisor = data['isSupervisor']
        this.isApiUser = data['isApiUser']
        this.isSuperUser = data['isSuperUser']
        this.isReports = data['isReports']
        this.canViewPBI = data['canViewPBI']
        this.isPBIRptsOnly = data['isPBIRptsOnly']
        this.isQRGenerater = data['isQRGenerater']
        this.userPhone = this._data.userPhone = (data['userPhone'] || data['phone'])
        this.userEmail = this._data.adUserEmail = (data['adUserEmail'] || data['adUserEmail'])

        this.userCountryCode = data['userCountryCode']
        this.fullName = data['adUserDisplayName']
        this.lastVersion = data['lastVersion']
        this.hideNewReleaseInfo = data["hideNewReleaseInfo"];
        this._setDataFromJWTToken(this.token)
    }

    static _setDataFromJWTToken(token) {
        // const payload = JSON.parse(atob(token.split('.')[1]))
        // this.username = payload['cognito:username']
        // this.userPoolId = payload['iss'].split('/')[3]

        if (this.username) {
            this._data.username = this.username;
            // this._data.userPoolId = this.userPoolId;
        }
        if (this.programId && this.clientId && !(this._data.programId && this._data.clientId)) {
            this._data.programId = this.programId;
            this._data.clientId = this.clientId;
        }
        this._data.created = new Date().getTime();
        cacheService.setCache('data', this._data);
        cacheService.setCache('releaseVersion', this._data['releaseVersion']);
        //console.log('Is Authenticated?', (this.isUserAuthenticated ? 'YES' : 'NO'))
        //console.log('Token expiry at', new Date(this.expiry * 1000))
        if (!this.userEventsChecker) {
            this.userEventsChecker = new UserEventsChecker(Auth)
        }
    }

    static setToken({ token, expiry, expiryInterval }) {
        //console.log('Set Token')
        let isNew = (!this.expiry || this.expiry <= expiry);
        console.log('ADCP: Is newer Token', isNew ? 'Yes' : 'No', isNew ? 'Updating' :
            'Current date:', (new Date((this.expiry) * 1000)),
            'compare to', (new Date(expiry * 1000)))
        if (isNew && token) {
            this.token = this._data['token'] = token;
            // this.accessToken = this._data['accessToken'] = access;
            this.expiry = this._data['expiry'] = expiry;
            this.expiryInterval = this._data['expiryInterval'] = expiryInterval;

            this._setDataFromJWTToken(this.token)
        }
    }

    static initialize() {
        // console.log('initialize User Data')
        let data = cacheService.getCache('data');
        this._clear();
        if (data && data.token) {
            this.setData(data)
        }
        this.initializeRoles();
    }

    static get data() {
        if (!this._data || !this._data.token) {
            //console.log('initialize User Data 2')
            this.initialize()
        }
        return this._data
    }

    static get isTokenExpired() {
        let data = this.data;
        if (data && data.token && data.expiry) {
            let now = new Date().getTime();
            let exp = new Date(data.expiry * 1000).getTime();
            if (!isNaN(exp) && (exp - now) <= 0) {
                return true;
            }
        }
        return false;
    }

    static get isTokenAboutToExpire() {
        let data = this.data;
        if (data && data.token && data.expiry) {
            let now = new Date().getTime();
            let exp = new Date(data.expiry * 1000).getTime();
            if (!isNaN(exp) && (exp - now) < 6 * 60 * 1000) {//less than 6 minute
                return true;
            }
        }
        return false;
    }

    static get isUserAuthenticated() {
        return (this.token && !this.isTokenExpired) ? true : false;
    }

    static async loginWithUserNameAndPassword(args) {
        let headers = {
            "Content-Type": "application/json"
        }
        const LOGIN_URL = `${AUTH_SERVICE_URL}${API_LISTS.BACKEND_USER_LOGIN}`
        const { data } = await axios.post(LOGIN_URL, getLoginParams(args), { headers })
        return this.afterLogin(data.data)
    }

    static afterLogin(data) {
        this._clearCache();
        this.expiry = 0;
        this.expiryInterval = 0;
        this.setData(data);
        return { token: data.token }
    }

    static logout() {
        this._clear();
        this._clearCache();
    }

    static doLogout() {
        this.logout()
        if (typeof this.logoutFn === 'function') {
            this.logoutFn();
        }
    }

    static subscribeTokenExpiry(fn) {
        this.logoutFn = fn;
    }
    
    static get userRolesData() {
        if (!this._rolesData) {
            this.initializeRoles()
        }
        return this._rolesData
    }

    static setRolesAndRights(data) {
        this.roleIds = data.roleIds
        this.rightObjects = data.rightObjects
        this.rights = data.rights
        this._rolesData = data
        cacheService.setCache('roles', data)
    }

    static initializeRoles() {
        let data = cacheService.getCache('roles');
        this.roleIds = undefined;
        this.rightObjects = undefined;
        this.rights = undefined;
        this._rolesData = undefined;
        if (data) {
            this.setRolesAndRights(data);
        }
    }

    //refreshToken
    static async refreshAuthJWT() {
        const REFRESH_TOKEN_URL = `${ADMIN_SERVIE_URL}${API_LISTS.REFRESH_AUTH_JWT}`;
        let headers = {
            "x-userid": this.userId,
            "Authorization": "Bearer " + this.token,
        }

        let {data} = await axios.post(REFRESH_TOKEN_URL, {}, {headers});
        this.setToken({token : data.token, expiry :  data.expiry, expiryInterval: data.expiryInterval});
        // this.afterLogin(data);
    }

}

export default Auth;



